var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"float-right",attrs:{"href":"#"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("« "+_vm._s(_vm.$t('historyback')))])])}
var staticRenderFns = []

export { render, staticRenderFns }